import { RootPaths } from "../App/paths";

export const CHAT_LIST_PATH = "chat";
export const CHAT_LIST_FULL_PATH = `${RootPaths.APP_V2_HOME}/${CHAT_LIST_PATH}`;

export const CHAT_PAGE_PATH = "chat/:facilityId";
export const CHAT_PAGE_FULL_PATH = `${RootPaths.APP_V2_HOME}/${CHAT_PAGE_PATH}`;

export const WORKPLACE_GROUP_CHAT_PAGE_PATH = "workplace-group-chat/:facilityId";
export const WORKPLACE_GROUP_CHAT_PAGE_FULL_PATH = `${RootPaths.APP_V2_HOME}/${WORKPLACE_GROUP_CHAT_PAGE_PATH}`;
